import { apiResourceUrl } from "@ploy-lib/core";
import { Resource } from "@rest-hooks/rest";
export class ApplicationResource extends Resource {
    pk() {
        return this.applicationNumber || "";
    }
}
ApplicationResource.urlRoot = apiResourceUrl("applications");
//# sourceMappingURL=ApplicationResource.js.map